// extracted by mini-css-extract-plugin
export var aboutSection = "index-module--aboutSection--HLDoG";
export var careersButton = "index-module--careersButton--nvL9X";
export var container = "index-module--container--EY06D";
export var description = "index-module--description--3VMz5";
export var gradBorder = "index-module--gradBorder--bqaRF";
export var imageBox = "index-module--imageBox--L8C7P";
export var section = "index-module--section--3yC4T";
export var textContainer = "index-module--textContainer---Tcas";
export var titleSection = "index-module--titleSection--jM-qF";
export var valueBox = "index-module--valueBox--XloQK";
export var valueHeading = "index-module--valueHeading--M2+2X";
export var valueSection = "index-module--valueSection--wvPsg";
export var valueSectionTitle = "index-module--valueSectionTitle--GrUMz";
export var values = "index-module--values--baPDi";